import { render, staticRenderFns } from "./AddressDataTable.vue?vue&type=template&id=62319d96&scoped=true&"
import script from "./AddressDataTable.vue?vue&type=script&lang=js&"
export * from "./AddressDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62319d96",
  null
  
)

export default component.exports